module.exports = __webpack_public_path__ + "static/media/logo-themoney.ef940e14.png";